import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useI18n } from "@/i18n";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { SectionHead } from "@/components/motion";
import { img } from "@/lib/gallery";

export const FaqList = ({ items, offset = 0 }) => (
  <Accordion type="single" collapsible className="border-t border-white/12" data-testid="faq-list">
    {items.map((x, i) => (
      <AccordionItem key={x.q} value={`q${i}`} className="border-white/12">
        <AccordionTrigger data-testid={`faq-q-${i + offset + 1}`} className="py-5 text-left text-base font-semibold hover:no-underline hover:text-[var(--gold)] md:text-lg">
          <span className="flex gap-4"><span className="font-mono text-xs text-[var(--gold)] pt-1.5">{String(i + offset + 1).padStart(2, "0")}</span>{x.q}</span>
        </AccordionTrigger>
        <AccordionContent className="pl-9 text-[var(--steel)] leading-relaxed">{x.a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);

export const FaqTeaser = () => {
  const { t } = useI18n();
  return (
    <section id="faq" className="bg-[var(--navy)] py-24 lg:py-32" data-testid="faq-teaser">
      <div className="container-x grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <SectionHead index="11" eyebrow={t.faq.eyebrow} title={t.faq.title} />
          <Link to="/faq" data-testid="faq-all-link" className="mt-8 inline-flex items-center gap-2 border-b border-[var(--gold)] pb-1 text-xs uppercase tracking-[0.16em] text-[var(--gold)]">{t.common.allFaq}<ArrowUpRight className="h-4 w-4" /></Link>
        </div>
        <div className="lg:col-span-8"><FaqList items={t.faq.items.slice(0, 7)} /></div>
      </div>
    </section>
  );
};

export const FinalCta = () => {
  const { t, eur } = useI18n();
  return (
    <section className="relative overflow-hidden" data-testid="final-cta">
      <img src={img(5)} alt="MB300 en exploitation" className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0 bg-[#070C1A]/80" />
      <div className="container-x relative py-28 lg:py-40">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--gold)]">MB300 · {t.hero.title}</p>
        <h2 className="font-display mt-5 max-w-4xl text-5xl font-black uppercase leading-[0.9] sm:text-7xl lg:text-8xl">{t.hero.tagline.join(" ")}</h2>
        <p className="mt-6 max-w-xl text-[var(--steel)]">{t.pricing.mainNote} {t.pricing.tiers.solo.name} : {eur(14500)} {t.common.ht}.</p>
        <Link to="/commander" data-testid="final-order-btn" className="group mt-10 inline-flex items-center gap-4 bg-[var(--gold)] px-8 py-5 text-sm font-bold uppercase tracking-[0.18em] text-[var(--night)] hover:bg-[var(--gold-hi)]">
          {t.common.order}<ArrowUpRight className="h-5 w-5 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
        </Link>
      </div>
    </section>
  );
};
